import React from 'react';
import { Box, Card, CardContent, Grid, LinearProgress, Typography } from '@mui/material';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import { PageHeader } from '../../../components/admin';
import { useHydrantStatistikyQuery, useHydrantPlanyQuery } from '../../../api/JsdhNotifikaceService/service/HydrantBodMutations';

const StatCard: React.FC<{ label: string; value: number; color?: string }> = ({ label, value, color }) => (
  <Card>
    <CardContent>
      <Typography variant="h3" sx={{ color: color || 'text.primary' }}>{value}</Typography>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
    </CardContent>
  </Card>
);

const HydrantDashboardPage: React.FC = () => {
  const { data: stat, isLoading } = useHydrantStatistikyQuery();
  const { data: plany } = useHydrantPlanyQuery();
  const aktivni = plany?.find((p) => p.plan.stav !== 'DOKONCENO');
  const progress = aktivni && aktivni.celkemPolozek > 0
    ? Math.round((aktivni.dokoncenoPolozek / aktivni.celkemPolozek) * 100) : 0;

  return (
    <Box>
      <PageHeader title="Hydranty" subtitle="Přehled evidence a kontrol" icon={<WaterDropIcon />} />
      {isLoading ? <LinearProgress /> : (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 6, md: 3 }}><StatCard label="Celkem" value={stat?.celkem ?? 0} /></Grid>
            <Grid size={{ xs: 6, md: 3 }}><StatCard label="OK" value={stat?.ok ?? 0} color="success.main" /></Grid>
            <Grid size={{ xs: 6, md: 3 }}><StatCard label="Závady" value={stat?.zavady ?? 0} color="error.main" /></Grid>
            <Grid size={{ xs: 6, md: 3 }}><StatCard label="Po termínu" value={stat?.poTerminu ?? 0} color="warning.main" /></Grid>
          </Grid>
          {aktivni && (
            <Card>
              <CardContent>
                <Typography variant="subtitle1">
                  Aktuální plán: {aktivni.plan.nazev} ({aktivni.dokoncenoPolozek}/{aktivni.celkemPolozek} dokončeno)
                </Typography>
                <LinearProgress variant="determinate" value={progress} sx={{ mt: 1, height: 10, borderRadius: 5 }} />
                <Typography variant="caption" color="text.secondary">{progress} %</Typography>
              </CardContent>
            </Card>
          )}
        </>
      )}
    </Box>
  );
};

export default HydrantDashboardPage;
